import React from "react";
import Alert from "react-bootstrap/Alert";

const ErrorMessage = ({ errors }) => (
  <>
    {Boolean(errors.length) && (
      <Alert variant="danger">
        <ul>
          {errors.map((error, i) =>
            typeof error === "string" ? (
              <li key={i}>{error}</li>
            ) : (
              <li
                key={i}
              >{`${error.reason} [${error.line}:${error.character}]`}</li>
            )
          )}
        </ul>
      </Alert>
    )}
  </>
);

export default ErrorMessage;
